import React, { Fragment } from 'react';
import {
  AppUserAdminActionCreators,
  ApplicationState,
  AppActionCreators,
  AppState
} from '../../store';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { Tabs, Tab, AppBar, Switch } from '@material-ui/core';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { withSnackbar, ProviderContext } from 'notistack';
import { IWorkflowService } from '../../services/Interfaces/IWorkflowService';
import { WorkflowSupplierGroupedDto } from '../../interfaces/Workflow';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, { MUIDataTableColumnOptions, MUIDataTableMeta, SelectableRows } from 'mui-datatables';
import { MUITranslations } from '../../helpers/MUITableTranslations';

interface IUserWorkflowSuppliersState {
  suppliers: WorkflowSupplierGroupedDto[];
  isLoading: boolean;
  organizationId: number;
}

type UserWorkflowSuppliersProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string }>;

class UserWorkflowSuppliers extends React.PureComponent<
  UserWorkflowSuppliersProps,
  IUserWorkflowSuppliersState
> {
  private translatorService!: ITranslatorService;
  private workflowService!: IWorkflowService;
  static contextType = ApplicationContext;

  state = {
    suppliers: [],
    isLoading: true,
    organizationId: 0
  } as IUserWorkflowSuppliersState;

  componentDidMount = () => {
    this.setState(
      {
        isLoading: true
      },
      () => {
        this.loadData();
      }
    );
  };

  loadData = async () => {
    const hoId = this.props.appState.appUser?.organizationId;

    if (!hoId) {
      return;
    }

    try {
      const data = await this.workflowService.GetDistinctWorkflowSuppliers(hoId);
      this.setState({
        suppliers: data,
        isLoading: false,
        organizationId: hoId
      });
    } catch (error) {
      this.setState({
        isLoading: false
      });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  getColumns = () => {
    const columns = [
      {
        name: 'supplierId',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'supplierName',
        label: this.translatorService.Tranlate('WORKFLOW_SUPPLIERS_TAB_SUPPLIER_LABEL', 'Furnizor')
      },
      {
        name: 'isActive',
        label: this.translatorService.Tranlate('USERS_IS_ACTIVE_HEADER', 'Activ'),
        options: {
          sort: false,
          filterOptions: {
            names: [
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ'),
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_INACTIVE', 'Inactiv')
            ],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(this.names[0]) !== -1 && isActive === true) ||
                (filterVal.indexOf(this.names[1]) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Switch
                checked={value ? value : false}
                onChange={(e) => this.handleIsActiveChange(e, tableMeta)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          }
        }
      }
    ];
    return columns;
  };

  handleIsActiveChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    tableMeta: MUIDataTableMeta
  ) => {
    const id = tableMeta.rowData[0];
    const suppliers = [...this.state.suppliers];
    const updatedSupplierIndex = suppliers.findIndex((o) => o.supplierId === id);

    if (updatedSupplierIndex >= 0) {
      suppliers[updatedSupplierIndex] = {
        ...suppliers[updatedSupplierIndex],
        isActive: event.target.checked
      };

      try {
        await this.workflowService.ChangeWorkflowSuppliersStatus({
          supplierId: suppliers[updatedSupplierIndex].supplierId,
          isActive: suppliers[updatedSupplierIndex].isActive,
          workflowSuppliersIds: suppliers[updatedSupplierIndex].workflowSuppliers.map((x) => x.id)
        });
        this.setState({ suppliers: suppliers });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.workflowService = (this.context as AppContext).workflowService;
    
    const options = {
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      elevation: 1
    };
    
    return (
      <Fragment>
        <AppBar position="static" elevation={0} color="secondary">
          <Tabs
            TabIndicatorProps={{
              style: {
                height: '4px'
              }
            }}
            value={0}
            onChange={undefined}
            variant="fullWidth"
            centered={true}
            indicatorColor="primary"
            aria-label="simple tabs example"
          >
            <Tab
              label={this.translatorService.Tranlate('USER_WORKLFOW_SUPPLIERS', 'Furnizori')}
            />
          </Tabs>
        </AppBar>
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
        </div>
        {!this.state.isLoading ? (
          <MUIDataTable
            title={''}
            data={this.state.suppliers}
            columns={this.getColumns()}
            options={options}
          />
        ) : null}
      </Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: UserWorkflowSuppliersProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});
export default connect(
  (state: ApplicationState) => ({ appState: state.app }),
  { ...AppUserAdminActionCreators, ...AppActionCreators },
  mergeProps
)(withSnackbar(UserWorkflowSuppliers as any));
